import { HireFieldsStep } from "./HireFieldsStep";

export function HireFirstStep() {
  return <HireFieldsStep group="main" />;
}
